import React, { useState } from 'react';
import { YesNoButtonWrapper } from '../../styles/GoalsQuestions.styles';
import Button from '@vfuk/core-button';
import SimpleGrid from '@vfuk/core-simple-grid';

interface YesNoButtonsListProps {
  keyPrefix: string;
  relatedQuestion: any;
  onClickHandler: (
    e: any,
    relatedQuestion: any,
    index: number,
    responseOption: string
  ) => void;
}

const YesNoButtonsList = ({
  keyPrefix,
  relatedQuestion,
  onClickHandler,
}: YesNoButtonsListProps) => {
  const [buttonSelected, setButtonSelected] = useState<number>(-1);
  const questionText = relatedQuestion.question.questionText;
  const responseOptions = relatedQuestion.question.responseOption;
  const questionId = relatedQuestion.question.id;
  return (
    <>
      <p className="assesment-sub-question">{questionText}</p>
      <SimpleGrid key={keyPrefix} justify="center">
        {responseOptions.map((responseOption: any, index: number) => {
          const buttonId = questionId + '_' + (index === 0 ? 'yes' : 'no');
          return (
            <YesNoButtonWrapper
              isSelected={index === buttonSelected}
              key={index}
            >
              <Button
                key={index + '-' + keyPrefix}
                dataAttributes={{
                  'data-testid':
                    index === 0
                      ? 'yes-button_' + questionId
                      : 'no-button_' + questionId,
                }}
                id={buttonId}
                text={responseOption}
                appearance="secondary"
                inverse
                onClick={(e: any) => {
                  onClickHandler(e, relatedQuestion, index, responseOption);
                  setButtonSelected(index);
                }}
              />
            </YesNoButtonWrapper>
          );
        })}
      </SimpleGrid>
    </>
  );
};

export default YesNoButtonsList;
